import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Dropdown from 'UIKit/Dropdown'
import Avatar from 'UIKit/Image/Avatar'
import Link from 'UIKit/Link'
import NextLinkFromReactRouter from 'UIKit/NextLink'
import Skeleton from 'UIKit/Skeleton'
import { RouteConfig } from 'config/constants/route'
import { ActionQueryEnum } from 'hooks/useActionQueryListener'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { useRouter } from 'hooks/useRouter'
import { RowCenter } from 'layout/Components/Row'
import UserMenuDropdown from 'layout/Components/UserMenu/UserMenuDropdown'
import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import { useCloseMenu, useMenuContainer } from 'state/app/hooks'
import { useUserInfo } from 'state/auth/hooks'
import { useUnreadNotificationAmount } from 'state/notification/hooks'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { getActionUrlSearch } from 'utils/urlHelper'
import { StyledText, StyledWrapIcon, StyledWrapTab } from './styled'

const StyledUnreadAmountDot = styled(Box)`
  width: 8px;
  height: 8px;

  border-radius: 50%;
  background: ${({ theme: { colors } }) => colors.strokeAlt3};
  position: absolute;
  top: -5px;
  right: -10px;
`

const BottombarUserMenu: React.FC<BoxProps> = ({ ...props }) => {
  const { unreadAmount } = useUnreadNotificationAmount()
  const { avatar } = useUserInfo()
  const { isMobile } = useMatchBreakpoints()

  const { isMenuOpen } = useMenuContainer()
  const { asPath } = useRouter()
  const renderContent = useCallback(() => {
    return (
      <StyledWrapTab id="bottom-bar-account" mx="auto" {...props}>
        <StyledWrapIcon>
          <RowCenter position="relative">
            {avatar ? (
              <Avatar src={avatar} width={24} height={24} alt="user avatar" />
            ) : (
              <Skeleton height={28} width={24} />
            )}
            <StyledUnreadAmountDot display={unreadAmount > 0 ? 'block' : 'none'} />
          </RowCenter>
        </StyledWrapIcon>
        <StyledText
          textAlign="center"
          $active={(asPath.includes('profile') || asPath === RouteConfig.Referral) && !isMenuOpen}
        >
          <Trans>Account</Trans>
        </StyledText>
      </StyledWrapTab>
    )
  }, [avatar, unreadAmount, asPath])

  return (
    <Box width="100%" id="bottombar-usermenu">
      {isMobile && <NextLinkFromReactRouter to={RouteConfig.MobileAccount}>{renderContent()}</NextLinkFromReactRouter>}
      {!isMobile && (
        <Dropdown dropdownContent={<UserMenuDropdown />} dropdownPosition="top-right">
          {renderContent()}
        </Dropdown>
      )}
    </Box>
  )
}

const UserItem = () => {
  const { hasSession } = useUserInfo()
  const closeMenu = useCloseMenu()

  return hasSession ? (
    <BottombarUserMenu />
  ) : (
    <StyledWrapTab onClick={closeMenu} id="bottom-bar-login" as={Link} href={getActionUrlSearch(ActionQueryEnum.Login)}>
      <StyledWrapIcon>
        <Icons.LoginIcon />
      </StyledWrapIcon>
      <StyledText>
        <Trans>Log in</Trans>
      </StyledText>
    </StyledWrapTab>
  )
}

export default React.memo(UserItem)
